<template>
  <button
    :class="[baseClass, sizeClass, variantClass, { 'opacity-80 cursor-not-allowed': loading || disabled } ]"
    :disabled="loading || disabled"
    @click="handleClick"
  >
    <slot>{{ label }}</slot>
    <svg
      v-if="loading"
      class="animate-spin h-4 w-4 ml-2 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
    <!-- Custom tooltip -->
    <span
      v-if="tooltip"
      class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 whitespace-nowrap
             opacity-0 group-hover:opacity-100 transition-opacity duration-150
             bg-gray-800 text-xs text-white py-1 px-2 rounded z-10 pointer-events-none"
    >
      {{ tooltip }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    label: String,
    tooltip: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['xl','lg','md','sm','xs'].includes(value)
    },
    variant: {
      type: String,
      default: 'default',
      validator: value => ['primary','info','danger','success','warning','default'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    baseClass() {
      // Add relative & group for tooltip
      return [
        'relative group inline-flex', 'border', 'items-center', 'justify-center',
        'font-medium focus:outline-none focus:ring-2 focus:ring-offset-2',
        this.radiusClass
      ].join(' ');
    },
    radiusClass() {
      if (this.rounded === true) return 'rounded-full';
      if (typeof this.rounded === 'string' && this.rounded) return `rounded-${this.rounded}`;
      return 'rounded';
    },
    sizeClass() {
      if (this.rounded === true) {
        return {
          xl: 'w-12 h-12',
          lg: 'w-10 h-10',
          md: 'w-8 h-8',
          sm: 'w-6 h-6',
          xs: 'w-4 h-4'
        }[this.size];
      }
      return {
        xl: 'text-lg px-6 py-3',
        lg: 'text-base px-5 py-2.5',
        md: 'px-4 py-2',
        sm: 'text-xs px-3 py-1.5',
        xs: 'text-xs px-2 py-1'
      }[this.size];
    },
    variantClass() {
      return {
        primary: 'bg-blue-500 hover:bg-blue-600 text-white focus:ring-blue-500',
        info:    'bg-cyan-600 hover:bg-cyan-700 text-white focus:ring-cyan-500',
        danger:  'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500',
        success: 'bg-green-600 hover:bg-green-700 text-white focus:ring-green-500',
        warning: 'bg-yellow-500 hover:bg-yellow-600 text-white focus:ring-yellow-400',
        default: 'bg-gray-200 hover:bg-gray-300 text-gray-800 focus:ring-gray-400'
      }[this.variant];
    }
  },
  methods: {
    handleClick(event) {
      if (!this.loading) this.$emit('click', event);
    }
  }
};
</script>
